import {
  IconBillRegular,
  IconGraphUpRegular,
  IconGroupRegular,
  IconMapPinRegular,
  IconServiceRegular,
} from "@packages/icon-library";
import { Permission } from "@/types";

export const NAVIGATION = [
  {
    type: "button",
    title: "Заказы",
    path: "/orders",
    icon: IconBillRegular,
    permission: Permission.ADMIN_ORDER_SHOW,
    children: ["OrderView", "OrdersList", "OrdersRequestList"],
  },
  {
    type: "section",
    title: "Секция товаров",
    items: [
      {
        type: "sub_menu",
        title: "Товары",
        slug: "productsCategories",
        icon: IconServiceRegular,
        items: [
          {
            type: "button",
            title: "Каталог",
            path: "/catalog",
            icon: null,
            children: ["ParamsCatalogList", "ParamsVariantsList"],
            permission: Permission.ADMIN_PRODUCT_VIEW,
          },
          {
            type: "button",
            title: "Параметры",
            path: "/params/category",
            children: [
              "ParamsCategory",
              "ParamsBrands",
              "ParamsColor",
              "ParamsOthers",
            ],
            permissionGroup: [
              Permission.ADMIN_BRAND_VIEW,
              Permission.ADMIN_CATEGORY_VIEW,
              Permission.ADMIN_FEATURE_VIEW,
            ],
          },
          {
            type: "button",
            title: "Склад",
            path: "/storage",
            children: ["StorageBalance", "StorageRequests", "StorageHistory"],
            permissionGroup: [
              Permission.ADMIN_WAREHOUSE_SHOW,
              Permission.ADMIN_HISTORY_POSITION_SHOW,
            ],
          },
        ],
      },
    ],
  },
  {
    type: "button",
    title: "Администраторы",
    path: "/admins",
    icon: IconGroupRegular,
    permission: Permission.ADMIN_USER_ADMIN_VIEW,
    children: ["AdminView"],
  },
  {
    type: "button",
    title: "ПВЗ",
    path: "/pvz",
    icon: IconMapPinRegular,
    permission: Permission.ADMIN_WAREHOUSE_SHOW,
    children: ["PvzView"],
  },
  {
    type: "button",
    title: "Маркетинг",
    path: "/marketing",
    icon: IconGraphUpRegular,
    permission: "",
  },
];
